import React, { Fragment } from 'react';
import '../loggedOut.css';

const NeuroPathways = () => {
   return (
    <Fragment>
        <div className="logged-out">
            <section className="service-hero scene scene--hero page-hero">
                <div className="container">
                    <div className="hero-grid">
                        <div className="hero-copy">
                            <h1 className="display-5 mb-4">Neuro Pathways</h1>
                            <p className="lead">
                                Our tutoring program is designed and delivered by experienced educators, with over 25 years of combined teaching experience.
                            </p>
                        </div>
                        <div className="hero-media text-center">
                            <div className="image-shell image-shell--hero">
                                <img
                                    src="/marketing_images/neuropathways/1.jpg "
                                    alt="Tutoring support session"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-philosophy scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <div className="row g-5 align-items-center">
                            <div className="col-md-6">
                                <p>
                                    We understand that everyone learns differently. Learning is a very personal journey, and our approach is tailored to each individual's strengths, interests, and support needs. Sessions are flexible and adapted so students can learn in ways that feel comfortable, achievable, and meaningful for them.
                                </p>
                                <p className="mb-0">
                                    Kindness, patience, and understanding are at the heart of everything we do. We focus on creating a safe, supportive environment where participants can build confidence, develop skills, and progress at their own pace without pressure.
                                </p>
                            </div>
                            <div className="col-md-6 text-center">
                                <div className="image-shell">
                                    <img
                                        src="/marketing_images/neuropathways/2.png "
                                        alt="Tutoring support session"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="learning-spaces scene scene--soft py-6">
                <div className="container text-center">
                    <p className="mb-5">
                        Tutoring can take place in your home or at our dedicated tutoring space in Plympton.
                    </p>
                    <div className="tile-grid">
                        {[
                            { title: "Classroom-style learning rooms", image: "/marketing_images/neuropathways/3.jpg " },
                            { title: "Well-equipped computer lab", image: "/marketing_images/neuropathways/4.jpg " },
                        ].map((space) => (
                            <div className="tile-card" key={space.title}>
                                <div className="image-shell image-shell--card">
                                    <img
                                        src={space.image}
                                        alt={space.title}
                                        className="img-fluid"
                                    />
                                </div>
                                <p className="mt-3 mb-0">{space.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="family-collaboration scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <div className="row align-items-center g-5">
                            <div className="col-md-6 text-center order-2 order-md-1">
                                <div className="image-shell">
                                    <img
                                        src="/marketing_images/neuropathways/5.jpg"
                                        alt="Family collaboration"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 order-1 order-md-2">
                                <p className="mb-0">
                                    We work closely with families to help each participant move toward their educational goals, while reducing barriers and supporting their individual needs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Fragment>
);

}

export default NeuroPathways;
